import React from 'react';

import cn from 'classnames';

import styles from './PulseCircles.module.scss';

interface PulseCirclesProps {
    color: string;
    animate?: boolean;
}

const PulseCircles: React.FC<PulseCirclesProps> = ({color, animate = false}) => (
    <>
        <div className={cn(
            styles.pulseCircle,
            color,
            { [styles.animate]: animate },
        )}
        />
        <div className={cn(
            styles.pulseCircle,
            color,
            { [styles.animate]: animate },
        )}/>
    </>
);

export default PulseCircles;